import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import SuccessFace from 'components/ui/AnimatedStates/SuccessFace';

const StyledContainer = styled.div`
  border-radius: 20px;
  width: 600px;
  height: 376px;
`;

const Success = ({ onClick, headerText, bodyText, buttonText }) => {
  const isMobile = window.matchMedia('(max-width: 750px)').matches;
  return (
    <StyledContainer>
      <SuccessFace
        onClick={onClick}
        headerText={
          headerText || getTranslatedString('landlordPortal.rentRoll.renewals.successHeader')
        }
        bodyText={bodyText || getTranslatedString('landlordPortal.rentRoll.renewals.successBody')}
        buttonText={
          buttonText || getTranslatedString('landlordPortal.rentRoll.renewals.successButton')
        }
        background={isMobile ? 'none' : 'white'}
      />
    </StyledContainer>
  );
};

export default Success;
